export default __webpack_public_path__ + "static/media/vidhya.67a53b54.jpg";